// @react-functional
import { useState, useEffect } from 'react';
import { LinkedArticleType } from '../../../legislation.types';
import { getLinkedLegislationArticles } from '../../../legislation.api';

export const useLinkedLegislationsFetcher = (
  articleId: string,
  category?: string | null,
  size?: number | null,
  content?: boolean | null,
) => {
  const [
    linkedLegislation,
    setLinkedLegislation,
  ] = useState<LinkedArticleType | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (articleId) {
        const linkedLegislationFetched = await getLinkedLegislationArticles(
          articleId,
          category,
          size,
          content,
        );
        setLinkedLegislation(linkedLegislationFetched);
      }
    };
    fetchData();
  }, [articleId, content, size, category]);

  return linkedLegislation;
};
